import { instance } from './axios.instance';

export const getRecursiveSectionFields = async (modelName, category) => {
  try {
    const query = category ? `?category=${encodeURIComponent(category)}` : '';
    const res = await instance.get(
      `/proposals/recursive_section_models/${modelName}/fields${query}`
    );
    if (res.status === 200) return res.data.fields;
  } catch (error) {
    console.error(error);
  }
  return [];
};

export const getRecursiveSectionRelationships = async () => {
  try {
    const res = await instance.get('/proposals/recursive_section_models/relationships');
    if (res.status === 200) {
      return { relationships: res.data.relationships ?? {}, modelLabels: res.data.model_labels ?? {} };
    }
  } catch (error) {
    console.error(error);
  }
  return { relationships: {}, modelLabels: {} };
};

export const getAvailableRootModels = async (work, templatable) => {
  try {
    const res = await instance.get('/proposals/recursive_section_models/available_root_models', {
      params: { work, templatable },
    });
    if (res.status === 200) return res.data;
  } catch (error) {
    console.error(error);
  }
  return { root_models: [], agreement_type: 'other' };
};

export const getRecursiveSectionData = async (documentId, modelName, { parentModel, parentId, documentType = 'opportunity', agreementType, sectionWork, force = false } = {}) => {
  const params = new URLSearchParams();
  if (parentModel) params.set('parent_model', parentModel);
  if (parentId) params.set('parent_id', parentId);
  if (agreementType) params.set('agreement_type', agreementType);
  if (sectionWork) params.set('work', sectionWork);
  // force=true (insertion) => relance la regen des screenshots planning/SP et
  // renvoie "" -> loader. force=false (re-fetch WS) => lecture seule (swap).
  if (force) params.set('force', 'true');
  const query = params.toString() ? `?${params.toString()}` : '';
  const scope = documentType === 'offer' ? 'offers' : 'opportunities';
  try {
    const res = await instance.get(
      `/proposals/${scope}/${documentId}/recursive_section_data/${modelName}${query}`
    );
    if (res.status === 200) return res.data.rows;
  } catch (error) {
    console.error(error);
  }
  // null, pas [] : un échec doit se distinguer d'un modèle réellement sans
  // ligne, sans quoi une réinitialisation viderait la section sur une erreur.
  return null;
};
